// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65179461","453":"9bc35570","455":"9f04cdc8","857":"6fe20295","977":"4f81eb53"}[chunkId] + ".chunk.js";
};